import { Box } from "@mui/material";
import { isEmpty, isNil, max, min } from "lodash";
import { DragEvent, useState } from "react";
import BaseItem from "./BaseItem";
import { ItemLightDto } from "./ItemDataTypes";
import { MixedPoolLabel } from "../../ootr/inventory/medallions/MedallionItem";

export interface ItemLabel {
    label: string,
    color?: string,
    groupKey?: string
}

interface MultiLabelItemProps {
    labels: Array<ItemLabel>
    indexLabel?: number,
    setIndexLabel?: (index: number) => void
    image: string,
    title: string,
    id: string,
    updateItem?: (value: ItemLightDto) => void,
    item?: ItemLightDto
    hideLabel?: true,
    isObtained?: number,
    setIsObtained?: (v: number) => void
}

const MultiLabelItem = (props: MultiLabelItemProps) => {

    let [isLocalObtained, setIsLocalObtained] = useState(0);
    let [localIndex, setLocalIndex] = useState(0);

    let index = !isNil(props.indexLabel) ? props.indexLabel : localIndex;
    let setIndex = !isNil(props.setIndexLabel) ? props.setIndexLabel : setLocalIndex;

    let isObtained = !isNil(props.isObtained) ? props.isObtained : isLocalObtained;
    let setIsObtained = !isNil(props.setIsObtained) ? props.setIsObtained : setIsLocalObtained;
    

    const handleClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        let obtained = (isObtained + 1) % 2
        setIsObtained(obtained)
        if(!isNil(props.updateItem) && !isNil(props.item))
            props.updateItem({...props.item, isObtained: obtained === 1 ? true : false})
    }

    const handleRightClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        e.preventDefault()
        let obtained = (isObtained + 1) % 2
        setIsObtained(obtained)

        if(!isNil(props.updateItem) && !isNil(props.item))
            props.updateItem({...props.item, isObtained: obtained === 1 ? true : false})
    }

    const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {

        let newIndex = 0;

        if (e.deltaY > 0 && index === 0)
            newIndex = props.labels.length - 1
        else if (e.deltaY > 0)
            newIndex = max([0, index - 1]) ?? 0
        else if (e.deltaY > 0 && index === props.labels.length - 1) {
            newIndex = 0
        }
        else if (e.deltaY < 0 && index === props.labels.length - 1)
            newIndex = 0
        else if (e.deltaY < 0)
            newIndex = min([props.labels.length - 1, index + 1]) ?? 0
        else
            newIndex = props.labels.length - 1

        setIndex(newIndex)
        
        console.log("index", newIndex, {...props.item, state: newIndex})
        
        if(!isNil(props.updateItem) && !isNil(props.item))
            props.updateItem({...props.item, state: newIndex})
    }

    const onDrop = (e: DragEvent<HTMLDivElement>) => {

        let result = e.dataTransfer.getData('text/plain');
        
        let mixpoolLabel = MixedPoolLabel.filter(x => x.label.toLocaleLowerCase() === result.toLocaleLowerCase());

        if(isNil(mixpoolLabel) || isEmpty(mixpoolLabel) || mixpoolLabel.length === 0)
            return;
        let index = MixedPoolLabel.indexOf(mixpoolLabel[0])

        setIndex(index)

        if(!isNil(props.updateItem) && !isNil(props.item))
            props.updateItem({...props.item, state: index})

    }



    let castIsObtained = !isNil(props.item) ? (props.item.isObtained ?? false) : isObtained > 0;
    let castState = !isNil(props.item) ? (props.item.state ?? 0) : index;


    return <Box component="div"
        display="flex"
        width={50}
        height={50}
        justifyContent="center"
        flexDirection={"column"}
        onWheel={handleWheel}
        sx={{
            color: castState === props.image.length ? "lightgreen" : "default",
            position: "relative",
            textAlign: "center",
            fontSize: "12px",
            touchAction: "none"
        }}
        onDrop={onDrop}
    >
        <BaseItem id={props.id} image={props.image} title={props.title} onClick={handleClick} onRightClick={handleRightClick} isObtained={castIsObtained} />

        {!props.hideLabel && <Box zIndex={999} marginTop={-1} marginLeft={-0.5} component="div" sx={{ color: props.labels[castState]?.color ?? "white",  fontWeight: "bold", userSelect: "none", textShadow: "1px 1px 2px black, 0 0 25px blue, 0 0 5px darkblue" }} onClick={handleClick} onContextMenu={handleRightClick} >{props.labels[castState]?.label}</Box>}
    </Box>

}

export default MultiLabelItem